import React from 'react'

export const CloseSmallIcon = () => (
  <svg
    width='8'
    height='8'
    viewBox='0 0 8 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5.28906 4.25L7.24219 2.29688C7.49609 2.0625 7.49609 1.67188 7.24219 1.4375L6.8125 1.00781C6.57812 0.753906 6.1875 0.753906 5.95312 1.00781L4 2.96094L2.02734 1.00781C1.79297 0.753906 1.40234 0.753906 1.16797 1.00781L0.738281 1.4375C0.484375 1.67188 0.484375 2.0625 0.738281 2.29688L2.69141 4.25L0.738281 6.22266C0.484375 6.45703 0.484375 6.84766 0.738281 7.08203L1.16797 7.51172C1.40234 7.76562 1.79297 7.76562 2.02734 7.51172L4 5.55859L5.95312 7.51172C6.1875 7.76562 6.57812 7.76562 6.8125 7.51172L7.24219 7.08203C7.49609 6.84766 7.49609 6.45703 7.24219 6.22266L5.28906 4.25Z'
      fill='#5F5F5F'
    />
  </svg>
)
